export function resetScroll(element) {
  while (element) {
    if (element.scrollHeight > element.clientHeight) {
      element.scrollTop = 0;
    }
    // Move up to the next parent element
    element = element.parentElement;
  }
}
